import axiosInstance from '../utils/axios';

export const GetBrand = async (values) => {
    return await axiosInstance().get('/getBrand', {
        params: values,
    });
};
